import { render, staticRenderFns } from "./BlogSavedBar.vue?vue&type=template&id=30d28a2e"
import script from "./BlogSavedBar.vue?vue&type=script&lang=js"
export * from "./BlogSavedBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports